import { render, staticRenderFns } from "./Article1MobileDefault.vue?vue&type=template&id=86d761c8&scoped=true&"
import script from "./Article1MobileDefault.vue?vue&type=script&lang=js&"
export * from "./Article1MobileDefault.vue?vue&type=script&lang=js&"
import style0 from "./Article1MobileDefault.vue?vue&type=style&index=0&id=86d761c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d761c8",
  null
  
)

export default component.exports